module.exports = __webpack_public_path__ + "static/media/parental_leave.1dd6b7a1.webp";